import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "button", "icon", "plusIcon", "minusIcon"]
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    this.updateState()
  }

  toggle(event) {
    event.preventDefault()
    this.openValue = !this.openValue
    this.updateState()
  }

  updateState() {
    if (this.openValue) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    if (this.hasContentTarget) {
      this.contentTarget.hidden = false
    }
    
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "true")
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.add("rotate-180")
    }

    if (this.hasPlusIconTarget && this.hasMinusIconTarget) {
      this.plusIconTarget.classList.add("hidden")
      this.minusIconTarget.classList.remove("hidden")
    }
  }

  close() {
    if (this.hasContentTarget) {
      this.contentTarget.hidden = true
    }
    
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "false")
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.remove("rotate-180")
    }

    if (this.hasPlusIconTarget && this.hasMinusIconTarget) {
      this.plusIconTarget.classList.remove("hidden")
      this.minusIconTarget.classList.add("hidden")
    }
  }

  openValueChanged() {
    this.updateState()
  }
}
